const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

export function generateLexoRankMidpoint(prevRank, nextRank) {
  prevRank = prevRank || '0';
  nextRank = nextRank || 'z';
  
  let result = '';
  for (let i = 0; i < Math.max(prevRank.length, nextRank.length) + 5; i++) {
    const ac = i < prevRank.length ? prevRank[i] : '0';
    const bc = i < nextRank.length ? nextRank[i] : 'z';
    
    if (ac === bc) {
      result += ac; // Characters match, carry forward
      continue;
    }
    
    const ai = CHARS.indexOf(ac);
    const bi = CHARS.indexOf(bc);
    const mid = Math.floor((ai + bi) / 2);
    
    if (mid !== ai && mid !== bi) {
      return result + CHARS[mid]; // Clean midpoint found
    }
    
    // Characters are adjacent, go one level deeper
    result += ac;
  }
  return prevRank + '1'; // Fallback fallback safety
}